<template>
  <div class="home">
    <v-container  
        class="overflow-y-auto"
    >
        <v-row >
            <v-layout wrap>
                <v-flex xs12 md8 lg8 xl8
                    class="pa-1"
                >
                    <v-carousel
                        cycle
                        :height="isMobile? '240px':height/10*8.5+'px'"
                        hide-delimiter-background
                        show-arrows-on-hover vertical
                    >
                        <v-carousel-item
                        v-for="(slide, i) in slides"
                        :key="i"
                        align="center"
                        >
                        <v-card>
                            <v-img
                            :src="'image/slide/'+slide.src"
                            class="white--text align-center"
                            :height="isMobile? '240px': height/10*8.4+'px'"
                            >
                                <v-card-title 
                                class="mb-6" 
                                color="gray"
                                >
                                    <!--<v-img
                                        gradient="to top right, rgba(200,10,10,.3), rgba(100,100,100,.9)"
                                        class="pa-1"
                                        >
        
                                        <template v-if="isMobile">
                                            <h5>
                                                <small>
                                                {{slide.text}}
                                                </small>    
                                            </h5>
                                        </template>
                                        <template v-else>
                                            <div class="text-body-2">
                                                {{slide.text}}
                                            </div>
                                        </template>
                                    </v-img>
                                    -->
                                </v-card-title>
                            </v-img>
                        </v-card>
                        
                        </v-carousel-item>
                    </v-carousel>
                </v-flex>
                <v-flex xs12 md4 lg4 xl4
                    class="pa-1"
                >
                    <v-list rounded dense >
                        <v-list-item-group color="red accent-1">
                            <v-list-item
                            v-for="(item, i) in items"
                            :key="i"
                            min-height="30px"
                            link
                            :href="item.link"
                            target="_blank"
                            class="text-decoration-none mb-0"
                            >
                                <v-list-item-icon class="mt-1 mb-1">
                                    <v-icon v-text="item.icon" :color="(i% 2 == 0)? 'red darken-4':'gray'"></v-icon>
                                </v-list-item-icon>
                                <v-list-item-content class="pt-0 pb-0">
                                    <h5 :class="(i % 2 == 0)? 'red--text text--darken-4':'gray'">{{item.text}}</h5>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>

                    </v-list>
                </v-flex>
            </v-layout>

            <!--<template>
                <v-carousel
                        cycle
                        :height="isMobile? '250px':height/1.8+'px'"
                        show-arrows-on-hover
                        hide-delimiters
                    >
                        <v-carousel-item
                        v-for="i in npag_noticias"
                        :key="i"
                        >
                            <v-container>
                                <v-row>
                                    <v-layout>
                                        <template v-if="isMobile">
                                            <v-flex xs6 v-for="(noticia, j) in noticias" :key="j" v-if="j >= ((i-1)*2) && j < (i*2) ">
                                                <v-card class="pa-1 grey--text text--darken-3 mr-2 ml-2" color="transparent" >
                                                    <v-img
                                                    :src="'image/noticias/'+noticia.src"
                                                    class="white--text align-center"
                                                    height="100"
                                                    >    
                                                    </v-img>
                                                    <v-card-actions>
                                                        <small>{{noticia.text}}</small>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-flex>
                                        </template>
                                        <template v-else>
                                            <v-flex xs3 v-for="(noticia, j) in noticias" :key="j" v-if="j >= ((i-1)*4) && j < (i*4) ">
                                                <v-card class="pa-1 grey--text text--darken-3 mr-2 ml-2" color="transparent" >
                                                    <v-img
                                                    :src="'image/noticias/'+noticia.src"
                                                    class="white--text align-center"
                                                    :height="isMobile? '240px':height/3+'px'"
                                                    >    
                                                    </v-img>
                                                    <v-card-actions> 
                                                        <h5>{{noticia.text}}</h5>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-flex>
                                        </template>
                                    </v-layout>
                                </v-row>
                            </v-container>


                        </v-carousel-item>
                </v-carousel>
            </template>
            -->

            <v-container>
			    <v-layout row>
                    <!--<v-flex md9 xs12>
                        <Noticias />
                    </v-flex>-->
                    <v-flex md12 xs12>
                        <Servicios />
                    </v-flex>
                </v-layout>
            </v-container>
        </v-row>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
  const Noticias = () => import('@/components/Noticias.vue')
  const Servicios = () => import('@/components/ServiciosH.vue')

export default {
    name: 'Home',
    components: {
        Noticias,
        Servicios
    },
    data(){
        return {
            isMobile: false,
            colors: [
                'indigo',
                'warning',
                'pink darken-2',
                'red lighten-1',
                'deep-purple accent-4',
            ],
            slides: [
                { src:'fachadacorte.jpg', link:'#'},
                { src:'atencion.jpeg', link:'#'},
                { src:'presidente_.jpg', link:'#'},
            ],
            items: [
                { text: 'CONSULTA DE EXPEDIENTES JUDICIALES - SUPREMO', icon: 'mdi-login', link: 'https://apps.pj.gob.pe/cejSupremo/'},
                { text: 'CONSULTA DE EXPEDIENTES JUDICIALES - SUPERIOR', icon: 'mdi-login', link: 'https://cej.pj.gob.pe/cej/forms/busquedaform.html'},
                { text: 'CONSULTA JUDICIAL', icon: 'mdi-login', link: 'https://cej.pj.gob.pe/consultajudicial/#/'},
                { text: 'SINOE', icon: 'mdi-login', link: 'https://casillas.pj.gob.pe/sinoe/login.xhtml'},
                { text: 'MESA DE PARTES ELECTRONICA', icon: 'mdi-login', link: 'https://casillas.pj.gob.pe/sinoe/login.xhtml'},
                { text: 'MESA DE PARTES VIRTUAL - CSJ PUNO', icon: 'mdi-login', link: 'http://suga.csjpuno.pe'},
                { text: 'CITAS ELECTRONICAS', icon: 'mdi-login', link: 'https://gestionsij.pj.gob.pe/citasMP/'},
                { text: 'FORMULARIO UNICO DE TRAMITE', icon: 'mdi-login', link: 'https://aplicativo.pj.gob.pe/formularioadministrativo/'},
                { text: 'CONSULTA DE NOTIFICACIONES JUDICIALES', icon: 'mdi-login', link: 'https://consernot.pj.gob.pe/sernot/'},
                { text: 'CONSULTA DE ANTECEDENTES PENALES', icon: 'mdi-login', link: 'https://www.pj.gob.pe/wps/wcm/connect/cortesuprema/s_cortes_suprema_home/as_servicios/as_enlaces_de_interes/as_registro_nacional_condenas'},
                { text: 'VISTAS DE CAUSA', icon: 'mdi-login', link: 'https://www.pj.gob.pe/wps/wcm/connect/CorteSuperiorPunoPJ/s_csj_puno_nuevo/as_servicios/as_servicios_ciudadano/as_vistas_causas/'},
                { text: 'EDICTOS JUDICIALES', icon: 'mdi-login', link: 'https://www.pj.gob.pe/wps/wcm/connect/CorteSuperiorPunoPJ/s_csj_puno_nuevo/as_servicios/as_servicios_ciudadano/as_edictos_judiciales/'},
            ],
            noticias:[
                { text:'PRESIDENTE DE LA CORTE DE PUNO SOSTUVO REUNIÓN CON DIRIGENTES DEL SINDICATO DE TRABAJADORES', src:'_1.jpg', link:'#'},
                { text:'PRESIDENTE DE LA CORTE SUPERIOR DE PUNO JURAMENTÓ COMO INTEGRANTE DEL COMITÉ REGIONAL DE SEGURIDAD CIUDADANA', src:'_2.jpg', link:'#'},
                { text:'JURAMENTAN MAGISTRADOS PROMOVIDOS A ÓRGANOS JURISDICCIONALES DEL DISTRITO JUDICIAL PUNO', src:'_3.jpg', link:'#'},
                { text:'EL DOCTOR PÁNFILO MONZÓN MAMANI ASUMIÓ LA PRESIDENCIA DE LA CORTE SUPERIOR DE JUSTICIA DE PUNO PARA EL PERIODO 2021-2022', src:'_4.jpg', link:'#'},
                { text:'SE REALIZÓ VISITA DE MONITOREO Y EVALUACIÓN DE LA IMPLEMENTACIÓN DE NUEVO CÓDIGO PROCESAL PENAL EN LA CSJ DE PUNO', src:'1.jpg', link:'#'},
                { text:'MODERNIZACIÓN DEL DESPACHO JUDICIAL EN LOS JUZGADOS CIVILES PERMITIRÁ OTORGAR TRANSPARENCIA Y CELERIDAD', src:'2.jpg', link:'#'},
                { text:'CAPACITAN A JUECES DE PAZ Y AUTORIDADES COMUNALES DEL DISTRITO DE PARATÍA EN LA PROVINCIA DE LAMPA', src:'3.jpg', link:'#'},
                { text:'SE REALIZÓ VISITA DE MONITOREO Y EVALUACIÓN DE LA IMPLEMENTACIÓN DE NUEVO CÓDIGO PROCESAL PENAL EN LA CSJ DE PUNO', src:'1.jpg', link:'#'},
                { text:'MODERNIZACIÓN DEL DESPACHO JUDICIAL EN LOS JUZGADOS CIVILES PERMITIRÁ OTORGAR TRANSPARENCIA Y CELERIDAD', src:'2.jpg', link:'#'},
                { text:'CAPACITAN A JUECES DE PAZ Y AUTORIDADES COMUNALES DEL DISTRITO DE PARATÍA EN LA PROVINCIA DE LAMPA', src:'3.jpg', link:'#'},
                { text:'SE REALIZÓ VISITA DE MONITOREO Y EVALUACIÓN DE LA IMPLEMENTACIÓN DE NUEVO CÓDIGO PROCESAL PENAL EN LA CSJ DE PUNO', src:'1.jpg', link:'#'},
                { text:'MODERNIZACIÓN DEL DESPACHO JUDICIAL EN LOS JUZGADOS CIVILES PERMITIRÁ OTORGAR TRANSPARENCIA Y CELERIDAD', src:'2.jpg', link:'#'},
            ]
        }
    },
    computed: {
      height () {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 220
                case 'sm': return 400
                case 'md': return 500
                case 'lg': return 600
                case 'xl': return 800
            }
        },
        npag_noticias() {
            if(this.isMobile)
                return Math.ceil(this.noticias.length / 2);
            else
                return Math.ceil(this.noticias.length / 4);
        }
    },
    mounted () {
        this.onResize()
        window.addEventListener('resize', this.onResize, { passive: true })
    },
    created(){
    },
    methods: {
        onResize () {
            this.isMobile = window.innerWidth < 600
        },
        onScroll (e) {
            console.log(e);
        },
    },
}
</script>
